import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  LanguageOutlined,
  LinkOutlined,
  PublicOutlined,
  PowerOutlined,
  ApiOutlined,
} from "@mui/icons-material";

import { useEBillProviderDetailContext } from "contexts/EBillProviderDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

const EBillProviderBasicDetail = () => {
  const { eBillProviderDetail, loadingEBillProvider } =
    useEBillProviderDetailContext();

  if (loadingEBillProvider) return <InfoGridSkeleton />;

  return (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <PublicOutlined color="primary" />}
            title="Country"
            subtitle={eBillProviderDetail?.country?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <LanguageOutlined color="primary" />}
            title="Provider Name"
            subtitle={eBillProviderDetail?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <LinkOutlined color="primary" />}
            title="Base URL"
            subtitle={eBillProviderDetail?.url || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <ApiOutlined color="primary" />}
            title="Endpoints"
            subtitle={
              <Chip
                label={`${eBillProviderDetail?.endpoints?.length ?? 0} configured`}
                size="small"
                variant="outlined"
                color="primary"
              />
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PowerOutlined color="primary" />}
            title="Created By"
            subtitle={eBillProviderDetail?.createdBy?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PowerOutlined color="primary" />}
            title="Updated By"
            subtitle={eBillProviderDetail?.updatedBy?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PowerOutlined color="primary" />}
            title="Default Provider"
            subtitle={
              <Chip
                label={eBillProviderDetail?.isDefault ? "Yes" : "No"}
                size="small"
                sx={{
                  backgroundColor: eBillProviderDetail?.isDefault
                    ? "#EBF5FB"
                    : "#F8F9F9",
                  color: eBillProviderDetail?.isDefault ? "green" : "#7F8C8D",
                  fontWeight: 500,
                }}
              />
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PowerOutlined color="primary" />}
            title="Status"
            subtitle={
              <Chip
                label={eBillProviderDetail?.isActive ? "Active" : "Inactive"}
                size="small"
                sx={{
                  backgroundColor: eBillProviderDetail?.isActive
                    ? "#EBF5FB"
                    : "#FDEDEC",
                  color: eBillProviderDetail?.isActive ? "green" : "#E74C3C",
                  fontWeight: 500,
                }}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EBillProviderBasicDetail;